export default {
  namespaced: true,
  state: {
    // 是否显示
    visible: false,
    // 组件类型 prompt 轻提示 popup 弹窗 loading 加载
    type: 'prompt',
    // 消息
    message: '',
    // 弹窗图标 success fail
    icon: '',
    // 展示时长(ms)，值为 0 时，toast 不会消失
    duration: 1500,
    // 完全展示后的回调函数
    onOpened: null,
    // 关闭时的回调函数
    onClose: null,
    // 取消时的回调
    onError: null,
    // 确认时的回调函数
    onSuccess: null,
    // 不管是确定还是取消按钮都执行回调
    onComplete: null,
    // 弹窗的取消
    cancelText: '取消',
    // 弹窗的确定
    confirmText: '确定'
  },
  mutations: {
    setOptions(state, data = {}) {
      Object.keys(data).map(key => {
        state[key] = data[key]
      })
    }
  }
}
